export enum DashboardView {
    DASHBOARD = 'dashboard',
    PROFILE = 'profile',
    LINKS = 'links',
    APPEARANCE = 'appearance',
    PREVIEW = 'preview',
    SETTINGS = 'settings'
} 

export enum STATUS {
    DEFAULT = 'default',
    PUBLISHED = 'published',
    DRAFT = 'draft',
    NOT_PUBLISHED = 'not-published'
}

export enum GuardState {
    IDLE = 'idle',
    VALID = 'valid',
    WARNING = 'warning',
    ERROR = 'error'
}